// extracted by mini-css-extract-plugin
module.exports = {"d976de0":"d976de0","mk86p4k":"mk86p4k"};